import type { CSSObject } from "@emotion/react";
export const tableDescriptionCss: CSSObject = {
  fontWeight: 400,
  margin: "4px 0 0",
};
